import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import "core-js/modules/es.string.trim-start.js";

function _wrapRegExp(re, groups) { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, undefined, groups); }; var _RegExp = _wrapNativeSuper(RegExp); var _super = RegExp.prototype; var _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = _RegExp.call(this, re, flags); _groups.set(_this, groups || _groups.get(re)); return _this; } _inherits(BabelRegExp, _RegExp); BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) result.groups = buildGroups(result, this); return result; }; BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if (typeof substitution === "string") { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } else if (typeof substitution === "function") { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = []; args.push.apply(args, arguments); if (typeof args[args.length - 1] !== "object") { args.push(buildGroups(args, _this)); } return substitution.apply(this, args); }); } else { return _super[Symbol.replace].call(this, str, substitution); } }; function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { groups[name] = result[g[name]]; return groups; }, Object.create(null)); } return _wrapRegExp.apply(this, arguments); }

import { strictParseByte, strictParseDouble, strictParseFloat32, strictParseShort } from "./parse-utils";
var DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
var MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export function dateToUtcString(date) {
  var year = date.getUTCFullYear();
  var month = date.getUTCMonth();
  var dayOfWeek = date.getUTCDay();
  var dayOfMonthInt = date.getUTCDate();
  var hoursInt = date.getUTCHours();
  var minutesInt = date.getUTCMinutes();
  var secondsInt = date.getUTCSeconds();
  var dayOfMonthString = dayOfMonthInt < 10 ? "0" + dayOfMonthInt : "" + dayOfMonthInt;
  var hoursString = hoursInt < 10 ? "0" + hoursInt : "" + hoursInt;
  var minutesString = minutesInt < 10 ? "0" + minutesInt : "" + minutesInt;
  var secondsString = secondsInt < 10 ? "0" + secondsInt : "" + secondsInt;
  return DAYS[dayOfWeek] + ", " + dayOfMonthString + " " + MONTHS[month] + " " + year + " " + hoursString + ":" + minutesString + ":" + secondsString + " GMT";
}
var RFC3339 = new RegExp( /*#__PURE__*/_wrapRegExp(/^([0-9]{4})\x2D([0-9]{2})\x2D([0-9]{2})[Tt]([0-9]{2}):([0-9]{2}):([0-9]{2})(?:\.([0-9]+))?[Zz]$/, {
  Y: 1,
  M: 2,
  D: 3,
  H: 4,
  m: 5,
  s: 6,
  frac: 7
}));
export var parseRfc3339DateTime = function parseRfc3339DateTime(value) {
  if (value === null || value === undefined) {
    return undefined;
  }

  if (typeof value !== "string") {
    throw new TypeError("RFC-3339 date-times must be expressed as strings");
  }

  var match = RFC3339.exec(value);

  if (!match || !match.groups) {
    throw new TypeError("Invalid RFC-3339 date-time value");
  }

  var year = strictParseShort(stripLeadingZeroes(match.groups["Y"]));
  var month = parseDateValue(match.groups["M"], "month", 1, 12);
  var day = parseDateValue(match.groups["D"], "day", 1, 31);
  return buildDate(year, month, day, match);
};
var IMF_FIXDATE = new RegExp( /*#__PURE__*/_wrapRegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), ([0-9]{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ([0-9]{4}) ([0-9]{2}):([0-9]{2}):([0-9]{2})(?:\.([0-9]+))? GMT$/, {
  D: 1,
  M: 2,
  Y: 3,
  H: 4,
  m: 5,
  s: 6,
  frac: 7
}));
var RFC_850_DATE = new RegExp( /*#__PURE__*/_wrapRegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), ([0-9]{2})\x2D(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\x2D([0-9]{2}) ([0-9]{2}):([0-9]{2}):([0-9]{2})(?:\.([0-9]+))? GMT$/, {
  D: 1,
  M: 2,
  Y: 3,
  H: 4,
  m: 5,
  s: 6,
  frac: 7
}));
var ASC_TIME = new RegExp( /*#__PURE__*/_wrapRegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|[0-9]{2}) ([0-9]{2}):([0-9]{2}):([0-9]{2})(?:\.([0-9]+))? ([0-9]{4})$/, {
  M: 1,
  D: 2,
  H: 3,
  m: 4,
  s: 5,
  frac: 6,
  Y: 7
}));
export var parseRfc7231DateTime = function parseRfc7231DateTime(value) {
  if (value === null || value === undefined) {
    return undefined;
  }

  if (typeof value !== "string") {
    throw new TypeError("RFC-7231 date-times must be expressed as strings");
  }

  var dayFn = function dayFn(value) {
    return parseDateValue(value, "day", 1, 31);
  };

  var yearFn = function yearFn(value) {
    return strictParseShort(stripLeadingZeroes(value));
  };

  var dateAdjustmentFn = function dateAdjustmentFn(value) {
    return value;
  };

  var match = IMF_FIXDATE.exec(value);

  if (!match || !match.groups) {
    match = RFC_850_DATE.exec(value);

    if (match && match.groups) {
      yearFn = parseTwoDigitYear;
      dateAdjustmentFn = adjustRfc850Year;
    } else {
      match = ASC_TIME.exec(value);

      if (match && match.groups) {
        dayFn = function dayFn(value) {
          return parseDateValue(value.trimLeft(), "day", 1, 31);
        };
      } else {
        throw new TypeError("Invalid RFC-7231 date-time value");
      }
    }
  }

  var year = yearFn(match.groups["Y"]);
  var month = parseMonthByShortName(match.groups["M"]);
  var day = dayFn(match.groups["D"]);
  return dateAdjustmentFn(buildDate(year, month, day, match));
};
export var parseEpochTimestamp = function parseEpochTimestamp(value) {
  if (value === null || value === undefined) {
    return undefined;
  }

  var valueAsDouble;

  if (typeof value === "number") {
    valueAsDouble = value;
  } else if (typeof value === "string") {
    valueAsDouble = strictParseDouble(value);
  } else {
    throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
  }

  if (Number.isNaN(valueAsDouble) || valueAsDouble === Infinity || valueAsDouble === -Infinity) {
    throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
  }

  return new Date(Math.round(valueAsDouble * 1000));
};

var buildDate = function buildDate(year, month, day, match) {
  var adjustedMonth = month - 1;
  validateDayOfMonth(year, adjustedMonth, day);
  return new Date(Date.UTC(year, adjustedMonth, day, parseDateValue(match.groups["H"], "hour", 0, 23), parseDateValue(match.groups["m"], "minute", 0, 59), parseDateValue(match.groups["s"], "seconds", 0, 60), parseMilliseconds(match.groups["frac"])));
};

var parseTwoDigitYear = function parseTwoDigitYear(value) {
  var thisYear = new Date().getUTCFullYear();
  var valueInThisCentury = Math.floor(thisYear / 100) * 100 + strictParseShort(stripLeadingZeroes(value));

  if (valueInThisCentury < thisYear) {
    return valueInThisCentury + 100;
  }

  return valueInThisCentury;
};

var FIFTY_YEARS_IN_MILLIS = 50 * 365 * 24 * 60 * 60 * 1000;

var adjustRfc850Year = function adjustRfc850Year(input) {
  if (input.getTime() - new Date().getTime() > FIFTY_YEARS_IN_MILLIS) {
    return new Date(Date.UTC(input.getUTCFullYear() - 100, input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds(), input.getUTCMilliseconds()));
  }

  return input;
};

var parseMonthByShortName = function parseMonthByShortName(value) {
  var monthIdx = MONTHS.indexOf(value);

  if (monthIdx < 0) {
    throw new TypeError("Invalid month: " + value);
  }

  return monthIdx + 1;
};

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

var validateDayOfMonth = function validateDayOfMonth(year, month, day) {
  var maxDays = DAYS_IN_MONTH[month];

  if (month === 1 && isLeapYear(year)) {
    maxDays = 29;
  }

  if (day > maxDays) {
    throw new TypeError("Invalid day for " + MONTHS[month] + " in " + year + ": " + day);
  }
};

var isLeapYear = function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};

var parseDateValue = function parseDateValue(value, type, lower, upper) {
  var dateVal = strictParseByte(stripLeadingZeroes(value));

  if (dateVal < lower || dateVal > upper) {
    throw new TypeError(type + " must be between " + lower + " and " + upper + ", inclusive");
  }

  return dateVal;
};

var parseMilliseconds = function parseMilliseconds(value) {
  if (value === null || value === undefined) {
    return 0;
  }

  return strictParseFloat32("0." + value) * 1000;
};

var stripLeadingZeroes = function stripLeadingZeroes(value) {
  var idx = 0;

  while (idx < value.length - 1 && value.charAt(idx) === "0") {
    idx++;
  }

  if (idx === 0) {
    return value;
  }

  return value.slice(idx);
};